import enFallback from './en-fallback/omnea-app.json'

// Keys stay literal so react-i18next's typed t() keeps working; leaf VALUES widen to string so the
// emitted declaration of this module only changes when a key is added or removed. Without this,
// every copy edit would change the declaration and invalidate every frontend project's typecheck.
type WidenLeaves<T> = { [K in keyof T]: T[K] extends string ? string : WidenLeaves<T[K]> }

export const i18nextFallbackResources: WidenLeaves<typeof enFallback> = enFallback
export const defaultNS = 'common'
